import React from "react"
import styles from "./CTAAnchorButton.module.scss"
import classnames from "classnames/bind"
import { OutboundLink } from '@assertiv/assertiv-gatsby-plugin-google-gtag'

export default ({ href = "/", content, className, contentClassName }) => {
  return (
    <OutboundLink
      href={href}
      className={classnames(
        styles.outboundDiv,
        styles.container,
        "d-inline-block border-white px-8 py-4",
        className
      )}>
      <div
        className={classnames(
          styles.content,
          "proxima-nova--regular fs-14pt ls-2px",
          contentClassName
        )}
      >
        {content}
      </div>
    </OutboundLink>
  )
}
